import React from "react";
import { MainDialog } from "../Dialgos/MainDialog";
import NotificationForm from "./form/NotificationForm";
import { useTranslation } from "react-i18next";
import { indexStore } from "src/store/indexStore";
function EditNotificationModel(props) {
  const { t } = useTranslation();
  const { notification, updateNotificationFunction } = indexStore();

  const handleSubmit = (values) => {
    updateNotificationFunction({
      ...values,
      id: notification.id,
      type: notification.type,
    });
  };
  return (
    <MainDialog
      trigger={props.trigger}
      title={t("gloabl.edit") + " " + t("gloabl.notification")}
    >
      <NotificationForm
        editMode={true}
        datasource={notification}
        onSubmit={handleSubmit}
      />
    </MainDialog>
  );
}

export default EditNotificationModel;
